import React from 'react';
import styled from 'styled-components';

import LaunchIcon from '@material-ui/icons/Launch';

import { colors } from '../../containers/S80/WindowConfig';
import { trimToMaxLength } from '../../utils/string.util';

const StyledDiv = styled.div`
  width: 100%;
  color: white;
  overflow: auto;
  height: 185px;
  border: 1px solid white;
`;

const StyledTdTh = styled.td`
  border: 1px solid white;
  padding: 4px;
`;

const StyledTable = styled.table`
  width: 100%;

  border-collapse: collapse;
  border: 1px solid white;
`;

const StyledThead = styled.thead`
  width: 100%;
  position: sticky;
  top: 0;
  background: ${colors.secondary};
`;

const StyledTbody = styled.tbody`
  display: table-row-group;
`;
const RotatedIcon = styled.div`
  transform: rotate(-90deg);
  display: inline-block;
  padding-left: 4px;
  cursor: pointer;
`;

export default function MultimediaAndHintReviewList({
  multiMediaAndHintReviews,
  showMediaAndReviewHintAction,
  executorResources,
}) {
  return (
    <StyledDiv>
      <StyledTable>
        <StyledThead>
          <tr>
            <StyledTdTh>Type</StyledTdTh>
            <StyledTdTh>Description</StyledTdTh>
            <StyledTdTh></StyledTdTh>
          </tr>
        </StyledThead>
        <StyledTbody>
          {multiMediaAndHintReviews.list.map((item, index) => {
            return (
              <tr key={index}>
                <StyledTdTh>
                  {multiMediaAndHintReviews.displayIndex === index && '> '}
                  {item.alertType}
                </StyledTdTh>
                <StyledTdTh>
                  {displayAlertDescription(
                    item.alertType,
                    item.actionPayload,
                    executorResources
                  )}
                </StyledTdTh>
                <StyledTdTh>
                  <RotatedIcon>
                    <LaunchIcon
                      onClick={() => {
                        showMediaAndReviewHintAction(index);
                      }}
                    />
                  </RotatedIcon>
                </StyledTdTh>
              </tr>
            );
          })}
        </StyledTbody>
      </StyledTable>
    </StyledDiv>
  );
}

const displayAlertDescription = (alertType, actionPayload, resources) => {
  if (alertType === 'hint') {
    return trimToMaxLength(actionPayload.hint, 40);
  }
  if (alertType === 'multimedia') {
    return trimToMaxLength(
      stripMessageOfAllHtmlTags(resources[actionPayload.asset]) || '',
      40
    );
  }
  if (alertType === 'image') {
    return 'image';
  }
  if (alertType === 'video') {
    return 'video';
  }
  return '';
};

const stripMessageOfAllHtmlTags = (message): string => {
  return message?.replace(/(<([^>]+)>)/gi, '');
};
